module.exports = __webpack_public_path__ + "static/media/Janda Romantic-01.90e721eb.svg";